import { render, staticRenderFns } from "./NilaiReview.vue?vue&type=template&id=60833252&lang=html&"
import script from "./NilaiReview.vue?vue&type=script&lang=js&"
export * from "./NilaiReview.vue?vue&type=script&lang=js&"
import style0 from "./NilaiReview.vue?vue&type=style&index=0&id=60833252&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports